<template>
  <div class="cards-ods">
    <div class="row">
      <div class="col-xs-12">
        <h2>Vinculação aos ODS (Objetivos do Desenvolvimento Sustentável)</h2>
        <p>
          Os dados abertos da Prefeitura de Santos são vinculados aos ODSs. Você
          pode consultá-los através das bandeiras abaixo:
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 lista-metas">
        <div
          v-for="meta in metas"
          :key="`meta-${meta.numero}`"
          class="card-metas"
        >
          <router-link
            :to="
              meta.cardTodos
                ? { name: 'listar_dados' }
                : { name: 'listar_dados', query: { metas: meta.codigo } }
            "
          >
            <div class="flip-card">
              <div class="flip-card-inner">
                <div class="flip-card-front">
                  <span v-if="meta.cardTodos">
                    Todas as metas
                  </span>
                  <img
                    :src="meta.cardTodos ? logo : `${imgUrl}${meta.imagem_url}`"
                    :alt="
                      `imagem representando ${
                        meta.cardTodos
                          ? 'todas as metas'
                          : `a meta ${meta.titulo}`
                      }`
                    "
                    :class="meta.cardTodos ? 'imgPMS' : 'imgODS'"
                  />
                </div>
                <div class="flip-card-back">
                  <p>{{ meta.objetivo }}</p>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//@ts-nocheck
export default {
  props: {
    metas: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      imgUrl: this.$root.$data.imgUrl,
      logo: require('@/assets/css/img/brasao-cor-branco-vertical.svg')
    }
  }
}
</script>

<style scoped>
.lista-metas {
  display: flex;
  flex-wrap: wrap;
}

.card-title {
  display: inline-block;
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 2rem;
  line-height: normal;
}

.card-metas {
  height: 15rem;
  width: 15rem;
  overflow: hidden;
}

.imgODS {
  width: 100%;
}

.imgPMS {
  width: 80%;
}

/* The flip card container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
.flip-card {
  background-color: transparent;
  width: 100%;
  height: 100%;
  border: 1px solid #f1f1f1;
  perspective: 1000px;
}

/* This container is needed to position the front and back side */
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

/* Do an horizontal flip when you move the mouse over the flip box container */
.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

/* Position the front and back side */
.flip-card-front,
.flip-card-back {
  position: absolute;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
  height: 100%;
  width: 100%;
}

/* Style the front side (fallback if image is missing) */
.flip-card-front {
  background-color: #25431d;
  color: black;
  text-align: center;
}

.flip-card-front > span {
  display: block;
  color: white;
  font-size: 1.5rem;
  padding: 5px;
}

/* Style the back side */
.flip-card-back {
  background-color: #fff;
  transform: rotateY(180deg);
  padding: 10px;
}

/* Small Devices, Tablets */
@media only screen and (max-width: 768px) {
  .lista-metas {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CardsODS/index.vue